<!-- 生产计划管理 -->
<template>
  <div class="plan_manage">
    <div class="filter_box">
      <el-select v-model="params.produceShop" placeholder="生产车间" @change="changeParams" style="margin-right: 10px;"
        clearable filterable >
        <el-option v-for="item in psList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <el-select v-model="params.orderNo" placeholder="销售单号" @change="changeParams" style="margin-right: 10px;"
        clearable filterable >
        <el-option v-for="item in onoList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <!-- <el-input placeholder="销售单号" v-model="params.orderNo" clearable @input="inputHandle"
        style="width: auto; margin-right: 10px;">
      </el-input> -->

      <el-select v-model="params.productNo" placeholder="产品编号" @change="changeParams" style="margin-right: 10px;"
        clearable filterable >
        <el-option v-for="item in pnList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <!-- <el-input placeholder="产品编号" v-model="params.productNo" clearable @input="inputHandle"
        style="width: auto;margin-right: 10px;">
      </el-input> -->
      <el-date-picker v-model="dateRang" type="daterange" :picker-options="pickerOptions" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" align="right" @change="changeRang" value-format="yyyy-MM-dd"
        @clear="initData" style="margin-right: 10px;">
      </el-date-picker>

    <!-- <el-upload ref="upload" class="right_btn" action="" :on-change="handleChange" :auto-upload="false">
        <el-button type="primary" :title="'导入数据'" icon="el-icon-upload2" />
        </el-upload> -->
      <el-button class="right_btn" type="primary" :title="'导入数据'" icon="el-icon-upload2" @click="openUploadBox" />
      <el-button class="right_btn" type="primary" icon="el-icon-date" @click="openRiliAll"></el-button>
    </div>

    <el-table :data="tableData" style="width: 100%" border v-loading="loading" @sort-change="sortChange">
      <el-table-column prop="produceShop" label="生产车间">
      </el-table-column>
      <el-table-column prop="customerPoNo" label="客户PO#.">
      </el-table-column>
      <el-table-column prop="orderNo" label="销售单号">
      </el-table-column>
      <el-table-column prop="shippingDate" label="出货日期" sortable="custom">
      </el-table-column>
      <el-table-column prop="productNo" label="产品编号">
      </el-table-column>
      <el-table-column prop="saleQuantity" label="销售数量" align="center" sortable="custom">
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="80" align="center">
      </el-table-column>
      <el-table-column prop="productCompleteQuantity" label="生产完成" align="center" :formatter="formatter">
        <!-- <template slot-scope="scope">{{ scope.row.productCompleteQuantity? scope.row.productCompleteQuantity:0}}</template> -->
      </el-table-column>
      <el-table-column prop="remainingQuantity" label="剩余数量" align="center" sortable="custom">
      </el-table-column>
      <el-table-column prop="capacity" label="产能" width="80" align="center">
        <template slot-scope="scope">{{ scope.row.capacity ? 'Y' : 'N' }}</template>
      </el-table-column>

      <el-table-column label="排产" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-date" size="small" @click="openRili(scope.row)"></el-button>
          <!-- <el-button type="text" style="color: #ff0000;" @click="toDelete(scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-pagination style="margin-top: 20px;" background :current-page.sync="params.pageNum" :page-sizes="[10, 20, 30, 50]"
      :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" />


    <!-- 订单排产计划日历 -->
    <el-dialog :visible.sync="dialogVisible" width="50%" title="生产排期" center>
      <!-- <div class="title_text"></div> -->
      <div class="det_text">
        <span>生产车间：{{ shopName }}</span>
        <span v-if="row.customerPoNo">客户PO#：{{ row.customerPoNo }}</span>
        <span v-if="row.orderNo">销售单号：{{ row.orderNo }}</span>
      </div>
      <el-calendar v-model="calendarDate" @input="caleInput" :first-day-of-week="7">
        <template slot="dateCell" slot-scope="{date, data}">
          <div :class="getDayQuantity(data.day) ? 'planDate' : ''" @click="handleDayData(data.day)">
            {{ data.day.slice(5) }}
            <p class="quantity">{{ getDayQuantity(data.day) }}</p>

            <!-- {{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}} -->
          </div>
        </template>
      </el-calendar>

    </el-dialog>

    <!-- 上传文档 -->
    <el-dialog :visible.sync="showUpload" width="500px">
      <el-upload ref="upload" class="upload-demo" drag action="" :file-list="fileList" :auto-upload="false" :on-preview="handlePreview"
        :on-remove="handleRemove" :on-change="handleChange">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传Excel文档，且格式符合模板文档！</div>
       
      </el-upload>
      <div v-if="fileList.length" style="text-align: center; margin-top: 20px;">
        <el-button size="small" type="primary" @click="submitUpload">上传文档</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPlanOrders, uploadExcel, getPlanList, getPlanCalendar, getProduceShopList, deletePlan,
  getOrderNoList, getProductNoList, getCustomerPoNoList } from "./req";
import { produceShops, getEndDay, add0 } from "./utils"
import router from '@/router'
let timer1;
export default {
  components: {},

  data () {
    return {
      showUpload: false,
      params: {
        "customerPoNo": "",
        "orderNo": "",
        "pageNum": 1,
        "pageSize": 10,
        "produceDateEnd": "",
        "produceDateStart": "",
        "produceGroup": "",
        "produceShop": "",
        "productNo": "",
        "shippingDateEnd": "",
        "shippingDateStart": "",
        orderByProperty: 1, // 排序字段。1创建时间，2出货日期，3销售数量，4剩余数量。默认为创建时间
        orderByType: 2 // 排序类型。1升序，2降序。默认降序
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      calendarDate: '',
      planList: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dateRang: '',
      row: {},
      riliRang: [],
      loading: false,
      produceShopList: [],
      fileList: [],
      orderNoList: [],
      productNoList: []
    };
  },
  computed: {
    psList () {
      let list = []
      this.produceShopList.forEach(item => {
        list.push({
          label: item,
          value: item
        })
      })
      return list
    },
    onoList () {
      let list = []
      this.orderNoList.forEach(item => {
        list.push({
          label: item,
          value: item
        })
      })
      return list
    },
    pnList () {
      let list = []
      this.productNoList.forEach(item => {
        list.push({
          label: item,
          value: item
        })
      })
      return list
    },
    shopName () {
      if (this.row.produceShop) return this.row.produceShop
      if (this.params.produceShop) return this.params.produceShop
      return '全部'
    }
  },
  // watch: {
  //   calendarDate (val) {
  //     console.log(val)
  //   }
  // },
  mounted () {
    console.log(router)
    this.initData()

    const year = new Date().getFullYear();
    const m = new Date().getMonth() + 1;
    const start = year + '-' + add0(m) + '-' + '01';
    const end = getEndDay(year, m)
    this.riliRang = [start, end]

    this.getSelectOptions()
  },
  methods: {
    sortChange (obj) {
      console.log(obj)
      this.params.orderByProperty = 1
      if (obj.prop == 'shippingDate') this.params.orderByProperty = 2
      if (obj.prop == 'saleQuantity') this.params.orderByProperty = 3
      if (obj.prop == 'remainingQuantity') this.params.orderByProperty = 4
      this.params.orderByType = obj.order == 'descending'?2:1
      this.params.pageNum = 1
      this.initData()
    },
    formatter (row) {
      return row.productCompleteQuantity? row.productCompleteQuantity:0
    },
    toDelete (row) {
      console.log('删除', row)
      this.$confirm(`此操作将永久删除该销售单号${row.orderNo} 数量${row.saleQuantity} ${row.unit}, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deletePlan(row.id).then(res => {
            if (res.resultCode == 1001) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.initData()
            }
          })

          
        })
    },
    openUploadBox () {
      this.showUpload = true
      this.fileList = []
    },
    submitUpload () {
      this.showUpload = false
      // this.$refs.upload.submit();
      console.log('提交', this.fileList)
      const list = this.fileList
      for (let index = 0; index < list.length; index++) {
        const file = list[index];
        uploadExcel(file).then(res => {
          if (res.resultCode == 1001) {
            this.$notify({
              title: '',
              message: this.$t('lease.Succeed'),
              type: 'success',
              duration: 2000
            })

            
            this.inputHandle()
            
          } else {
            this.$message.error(res.resultMessage)
          }
        })
      }
      
    },
    handleRemove (file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList
    },
    handlePreview (file) {
      console.log(file);
    },
    getSelectOptions () {
      getProduceShopList().then(res => {
        if (res.resultCode == 1001) {
          this.produceShopList = res.resultModel
        }
      })

      getOrderNoList({
        "produceDateEnd": "",
        "produceDateStart": "",
        "produceGroup": "",
        "produceShop": ""
      }).then(res => {
        if (res.resultCode == 1001) {
          this.orderNoList = res.resultModel
        }
      })

      getProductNoList({
        "produceDateEnd": "",
        "produceDateStart": "",
        "produceGroup": "",
        "produceShop": ""
      }).then(res => {
        if (res.resultCode == 1001) {
          this.productNoList = res.resultModel
        }
      })
    },
    inputHandle () {
      if (timer1) {
        clearTimeout(timer1)
      }
      timer1 = setTimeout(() => {
        this.initData()
      }, 500);
    },
    // 上一个
    caleInput (val) {
      // console.log(JSON.stringify(this.row))
      if (JSON.stringify(this.row) != '{}')  return
      
      // console.log('caleInput',val)
      const date = new Date(val)
      const fullDate = date.getFullYear() + '-' + add0(date.getMonth() + 1) + '-' + add0(date.getDate())
      console.log('caleInput', fullDate)
      const year = date.getFullYear();
      const month = date.getMonth() + 1
      this.riliRang[0] = year + '-' + add0(month) + '-01'
      this.riliRang[1] = getEndDay(year, month)
      this.openRiliAll()
    },
    handleDayData (day) {
      console.log(day)
      this.dateRang = [day, day]
      this.dialogVisible = false
      setTimeout(() => {
        this.initData()
      }, 100);

    },
    // 打开日历，所有的
    openRiliAll () {
      this.row = {}
      const params = {
        "customerPoNo": this.params.customerPoNo,
        "endDate": this.riliRang[1],
        "orderNo": this.params.orderNo,
        "produceGroup": this.params.produceGroup,
        "produceShop": this.params.produceShop,
        "productNo": this.params.productNo,
        "startDate": this.riliRang[0]
      }
      getPlanCalendar(params).then(res => {
        console.log('计划日历：', res)
        if (res.resultCode == 1001) {
          this.planList = res.resultModel
          this.dialogVisible = true
        } else {
          this.$message.error(res.resultMessage)
        }
      })
    },
    changeRang (val) {
      console.log(val)
      this.initData()
    },
    getDayQuantity (day) {
      const obj = this.planList.find(item => item.date == day)
      if (obj) return obj.quantity
      return ''
    },
    // 打开日历，单个订单排期
    openRili (row) {
      this.row = row
      getPlanList(row.orderNo).then(res => {
        console.log('订单计划：', res)
        if (res.resultCode == 1001) {
          this.dialogVisible = true
          this.planList = res.resultModel
          if (this.planList.length) {
            this.calendarDate = this.planList[0].date
          }

        }
      })
    },
    handleChange (file, fileList) {
      console.log(file)
      console.log(fileList)
      this.fileList = fileList
      
      // this.$refs.upload.clearFiles()
      const arr = file.name.split('.')
      if (arr[arr.length - 1] == 'xlsx' || arr[arr.length - 1] == 'xls') {
        // uploadExcel(file).then(res => {
        //   if (res.resultCode == 1001) {
        //     this.$notify({
        //       title: '',
        //       message: this.$t('lease.Succeed'),
        //       type: 'success',
        //       duration: 2000
        //     })
        //     this.initData()
        //   } else {
        //     this.$message.error(res.resultMessage)
        //   }
        // })
      } else {
        this.$notify({
          title: this.$t('adminView.IncorrectFile'), // '文件名后缀错误！',
          message: '请上传Excel文档', // '文件名后缀必须为 "bin" ',
          type: 'error',
          duration: 4000
        })
        const index = this.fileList.findIndex(item => item.uid == file.uid)
        this.fileList.splice(index, 1)
      }


    },
    changeParams (value) {
      console.log(value)
      this.initData()
    },
    // 分页----start
    handleSizeChange (val) {
      this.params.pageSize = val
      this.initData()
    },
    handleCurrentChange (val) {
      this.params.pageNum = val
      this.initData()
    },
    initData () {


      this.loading = true
      if (this.dateRang) {
        this.params.produceDateStart = this.dateRang[0]
        this.params.produceDateEnd = this.dateRang[1]
      } else {
        this.params.produceDateStart = this.params.produceDateEnd = ''
      }
      getPlanOrders(this.params).then(res => {
        this.loading = false
        console.log(res)
        if (res.resultCode == 1001) {
          this.tableData = res.resultModel.list
          this.total = res.resultModel.total
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.plan_manage {
  padding: 15px;
  background-color: #fff;
  border-radius: 5px;
}

.filter_box {
  margin-bottom: 15px;
}

.right_btn {
  float: right;
  margin: 0 10px;
}

.quantity {
  font-size: 24px;
  text-align: center;
}

.planDate {
  background-color: rgba($color: #95acdd, $alpha: 0.5);
  height: calc(100% + 20px);
  padding: 10px;
  margin: -9px;
}

.det_text {
  font-size: 16px;
  padding: 0 20px;

  span {
    margin-right: 20px;
  }
}

.upload-demo {
  text-align: center;
}
.title_text {
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}
</style>